import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { PaginationInput } from '../../../../types/schema/utils.types';
import { Notice } from '../../../../types/schema/notice.types';

interface GetAllNoticesHook {
  data: Notice[] | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllNotices: Notice[];
    }>
  >;
}

interface GetAllNoticesMutationData {
  getAllNotices: Notice[];
}

interface GetAllNoticesInputType {
  input: PaginationInput;
}

export function useGetAllNotices(
  query: DocumentNode,
  input: PaginationInput
): GetAllNoticesHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    GetAllNoticesMutationData,
    GetAllNoticesInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllNotices,
    loading,
    error,
    refetch,
  };
}
